import React from 'react';
import { Alert, ProgressBar } from 'react-bootstrap';
import FormStripe from '../../components/FormStripe/FormStripe';
import config from '../../constants/config';
import { CompanyT } from '../../types/Company';
import { AxiosInstance, unauthorizedRequest } from '../../utils/RequestMethods';
import { parseFloatTotal } from '../jobs/NewJob/Job';
import IosArrowBack from 'react-ionicons/lib/IosArrowBack'
import IosHome from 'react-ionicons/lib/IosHome'
import { JobT } from '../../types/Job';
import { Button } from '@mui/material'
import { UserT } from '../../types/Users';
import { LineItemTransactionT } from '../../types/TransactionT';
import { randomId, withQuery } from '../../utils'
export type IScreenFormStripeProps = {
    tokenUser : string
    user : UserT
    job : JobT
    deposit : number
    company : CompanyT
    goBack(reset : boolean) : void

}

const ScreenFormStripe: React.FC<IScreenFormStripeProps> = (props) => {
    // const [disabledButttonBack, setDisabledButttonBack] = React.useState(false);
    const [processing, setProcessing] = React.useState(false);
    const [hasPaid, setHasPaid] = React.useState(false)
    /**
   *
   * @param data
   * @returns
   */
    const onSuccessPaymentIntent = async (paymentIntentId: string): Promise<string> => {
        setProcessing(true)

        let params = {
            paymentIntentId: paymentIntentId,
        }
        let options = {
            // data: params,
            headers: {
                'Authorization': `Bearer ${props.tokenUser}`
            }
        }

        try {
            let res = await AxiosInstance.post(`${config.url.transactions}/confirm`, params, options)
            if (res && res.data) {
                setProcessing(false)
                setHasPaid(true)

                return res.data.status;
            } else {
                setProcessing(false)
                throw new Error("Unknown error occurred");

            }
        } catch (error) {
            setProcessing(false)
            throw new Error(error);
        }
    }


    /**
     *
     * @param data
     * @returns
     */
    const createPaymentIntent = async (data): Promise<string> => {

        let params = {
            userId: props.user.id,
            productId: props.job.id,
            productType: "jobs",
            lineItems: [
                {
                    productItemId: randomId(12),
                    productItem: "serviceFee",
                    amount: props.deposit,
                    productRate: props.deposit,
                    productUnits: 1,
                }
            ]
        }
        params = { ...params, ...data }

        let options = {
            // data: params,
            headers: {
                'Authorization': `Bearer ${props.tokenUser}`
            }
        }
        try {
            let res = await AxiosInstance.post(`${config.url.transactions}/checkout`, params, options)

            if (res && res.data) {

                return res.data.clientSecret;
            } else {

                throw new Error("Unknown error occurred");

            }
        } catch (error) {

            throw new Error(error);
        }
    }

    const renderSuccessResult = () => {
        return (
            <div>
                <Alert variant="success">
                    Your job is booked!
                </Alert>
            </div>
        )
    }
    return (
        <div>

            <p>Pay the <strong>${parseFloatTotal(props.deposit)}  service fee</strong> to schedule your move. </p>
            <hr />
            {(!processing && !hasPaid) && <FormStripe amount={props.deposit} publishableKey={config.stripePublishableKey}
                billingDetails={{

                }}
                createPaymentIntent={createPaymentIntent}
                onSuccessPaymentIntent={onSuccessPaymentIntent}
                renderSuccessResult={(
                    <>
                        {renderSuccessResult()}
                    </>
                )}
            />}
            {hasPaid && renderSuccessResult()}

            <Button
                disabled={processing}
                style={{
                    marginTop: 10,
                    marginLeft: 0
                }}
                onClick={() => {
                    props.goBack(hasPaid)
                }}
                color="success"
                variant="contained">

                <IosHome
                    color="white" />
                &nbsp; Home
            </Button>
        </div>
    );
}

export default ScreenFormStripe
